export enum Language {
	PT = "PT",
	EN = "EN",
	ES = "ES"
}